import { Component, OnInit, OnDestroy, Output, EventEmitter } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { forkJoin, Subject, Subscription } from "rxjs";
import { progressDetails } from "src/app/feature-modules/student-list/models/progressDetails";
import { School } from "src/app/shared/models/school";
import { Student } from "src/app/shared/models/student-base";
import { ApiDataService } from "src/app/shared/services/api.service";
import { StudentsApiService } from "../../../student-list/services/students-api.service";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { takeUntil } from "rxjs/operators";
import { AppRouteConstants } from "src/app/shared/constants/app-route.constants";
import { SuccessMessages } from "src/app/shared/constants/utility.constants";
import { StudentInfo } from "src/app/shared/models/studentinfo";
import { Tutor } from "src/app/shared/models/tutor-base";
import { StorageService } from "src/app/shared/services/storage.service";
import { Lesson } from "../../../lessons/models/lesson";
import { LessonsApiService } from "../../../lessons/services/lessons-api.service";
import { Reason } from "../../../student-list/models/reason";
import { StudentUtility } from "../../../student-list/services/student-utility-services";
import { StudentConstants } from "../../../student-list/constants/student.constants";
import { UtilityService } from "src/app/shared/services/utility.service";
import { enagagementTabs, errorMessages, sesssionConstants } from "../../constants/passage-constants";

@Component({
    selector: "start-page",
    templateUrl: "./start-page.component.html",
    styleUrls: ["./start-page.component.css"],
    standalone: false
})
//This component is under development and may contain unused code.
export class StartPage implements OnInit, OnDestroy {
  subscription: Subscription;
  loading = true;
  lessonControl: UntypedFormControl = new UntypedFormControl();
  tutorControl: UntypedFormControl = new UntypedFormControl();
  reasonControl: UntypedFormControl = new UntypedFormControl();
  studentControl: UntypedFormControl = new UntypedFormControl();
  schoolControl: UntypedFormControl = new UntypedFormControl();
  selectedSchool = -1;
  selectedStudent = -1;
  selectedLesson1 = -1;
  schoolList: School[] = [];
  schoolOptions: School[] = [];
  studentList: Student[] = [];
  filteredStudentList: Student[] = [];
  gradeId: number = -1;
  lessons: Lesson[] = [];
  selectedLesson: any = {};
  tutors: Tutor[] = [];
  tutorOptions: Tutor[] = [];
  lessonOptions: Lesson[] = [];
  reasons: Reason[] = [];
  updateStudentProgressGroup: UntypedFormGroup;
  student: any;
  studentId = -1;
  tutorId: number;
  lessonId: number;
  lessonIdCopy: number;
  progressDetails: progressDetails;
  edit: boolean;
  absentValue: string[] = ["Yes", "No"];
  sessionId: any;
  wasStudentAbsent = false;
  maxDate: Date;
  studentInfo: StudentInfo = {
    school: -1,
    isActive: 1,
    grade: -1,
    searchTerm: "",
    limit: 50,
    offset: 0,
    controlGroup: 0,
  };
  loggedInUserRoleId: number;
  isLessonSelected = false;
  selectedReasonForAbsence = -1;
  studentListLoadingInProgress = false;
  lessonListLoadingInProgress = false;
  miroBoardLink: string = "";
  isLoading = false;
  lessonsLoaded = false;
  userEmail = "";
  tutorTipModal = false;
  tutorTip = "";
  niceToMeetYouLink = "";
  zoomLink = "";
  isTrainingSchool :boolean = false;
  private ngUnsubscribe = new Subject <void>();
  constructor(
    private apiService: ApiDataService,
    private studentApiService: StudentsApiService,
    private lessonsApiService: LessonsApiService,
    private toastrService: ToastrService,
    public _location: Location,
    private router: Router
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    if (this.router.url.search(AppRouteConstants.TUTOR_UPDATE_PROGRESS) > 0) {
      localStorage.setItem(
        "previousURL",
        AppRouteConstants.TUTOR_UPDATE_PROGRESS
      );
    }
    StorageService.clearSessionData()
    this.tutorId = Number(StorageService.getUserId());
    this.getUserInfo(() => {
      this.getSchools(this.tutorId);
    });
    this.maxDate = new Date();

    this.studentControl.valueChanges.subscribe((value) => {
      this.filteredStudentList = StudentUtility.filterOptions(
        this.studentList,
        value,
        ["UserName"]
      );
    });

    this.schoolControl.valueChanges.subscribe((value) => {
      this.schoolOptions = StudentUtility.filterOptions(
        this.schoolList,
        value,
        ["school_name"]
      );
    });
    this.getNiceToMeetYouLink()
        const absenceSuccessMessage = sessionStorage.getItem(
      "absenceSuccessMessage"
    );

    if (absenceSuccessMessage) {
      this.toastrService.success(absenceSuccessMessage);
      sessionStorage.removeItem("absenceSuccessMessage");
    }
  }

  getNiceToMeetYouLink() {
    try {
      this.apiService
        .getAppLinkURL('Nice to Meet You')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response) => {
          if (response) {
            this.niceToMeetYouLink = response.link;
          }
          this.loading = false;
        });
    } catch (error) {
      console.error("Error in getNiceToMeetYouLink:", error);
    }
  }

  tutorTipModalOpen(value: boolean) {
    this.tutorTipModal = value;
  }

  getUserInfo(callback: any) {
    this.loading = true;
    this.subscription = this.apiService.getUserInfo().subscribe((res) => {
      if (res) {
        this.loggedInUserRoleId = res.role.id;
        this.userEmail = res.email;
        if (callback) {
          callback();
        }
      }
    });
  }

  maskLastName(fullName: string): string {
    const nameParts = fullName.split(" ");
    if (nameParts.length >= 2) {
      let lastName = nameParts[nameParts.length - 1];
      // Only show the first two letters of the last name
      const visibleLetters = Math.min(2, lastName.length);
      const maskedLastName = `${lastName.slice(0, visibleLetters)}${"*".repeat(
        Math.max(0, lastName.length - visibleLetters)
      )}`;
      nameParts[nameParts.length - 1] = maskedLastName;
      return nameParts.join(" ");
    } else {
      return fullName;
    }
  }

  checkBoxChanges(event: any) {
    this.wasStudentAbsent = event.value;
  }
  handleStudentAbsentCancel() {
    this.wasStudentAbsent = false;
    this.updateStudentProgressGroup.patchValue({
      control_group: false,
    });
  }

  getSchools(tutorId: number) {
    if (this.loggedInUserRoleId === 1 || this.loggedInUserRoleId === 2) {
      this.subscription = this.apiService.getSchoolList().subscribe((res) => {
        this.sort(res);
      });
    } else {
      this.apiService
        .tutorsAssociatedWithSchool(tutorId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res) => {
          this.sort(res);
        });
    }
  }

  sort(res: any) {
    if (res) {
      this.schoolList = res;
      this.schoolOptions = res;
      this.schoolList = this.schoolList.sort((a, b) => {
        // if (a.id < b.id) return -1;
        // if (a.id > b.id) return 1;
        // Sort by school_name alphabetically
        if (a.school_name < b.school_name) return -1;
        if (a.school_name > b.school_name) return 1;
        return 0;
      });
      this.loading = false;
    }
  }

  getSelectedStudentDetails() {
    this.apiService
      .getStudent(this.studentId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res && res.gradeIddd !== undefined) {
          this.student = res;
          this.getData(this.edit);
        }
      });
  }

  getData(edit: boolean) {
    this.lessonListLoadingInProgress = true;
    // New sessions use placement-aware lessons; edit flows retain their
    // existing lesson list behavior.
    const lessonsRes = edit
      ? this.lessonsApiService.getLessonNames()
      : this.studentApiService.getPlacementAwareLessons(
          this.selectedStudent,
          this.gradeId
        );
    const tutorsRes = this.apiService.getVolunteerNames();
    const reasonRes = this.apiService.getAllReason();
    forkJoin([lessonsRes, tutorsRes, reasonRes])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((joinedRes) => {
        if (joinedRes && joinedRes.length) {
          this.lessons =
            joinedRes[0] && joinedRes[0].length ? joinedRes[0] : [];
          this.lessonOptions = this.lessons;
          if (!edit) {
            // Preselect the next available lesson returned by the API.
            this.selectedLesson1 = this.lessonOptions[0]?.id ?? -1;
            this.lessonsLoaded = true;
            if (this.selectedLesson1 !== -1) {
              this.setSelectedLesson(this.selectedLesson1);
            }
          }
          this.tutors = joinedRes[1] && joinedRes[1].length ? joinedRes[1] : [];
          this.tutorOptions = this.tutors;
          this.reasons =
            joinedRes[2] && joinedRes[2].length ? joinedRes[2] : [];
          if (edit) {
            this.setSelectedLesson(this.progressDetails.lesson_id);
          }
        }
        this.lessonListLoadingInProgress = false;
      });
  }


  onNiceToMeetYouClick() {
    UtilityService.urlOpen(this.niceToMeetYouLink)
  }
  openZoomClassroom() {
    UtilityService.urlOpen(this.zoomLink);
  }

  setSelectedLesson(lessnId: number) {
    try {
      this.isLoading = true;
      this.miroBoardLink = "";
      this.lessonIdCopy = lessnId;

      this.selectedLesson = this.lessons.find((les) => les?.id === lessnId);
      this.isLessonSelected = lessnId === -1 ? false : true;

      this.apiService
        .getLessonTutorTips(lessnId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res) => {
          if (res) {
            this.tutorTip = res.tutor_tips;
            this.tutorTipModalOpen(true)
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  @Output() changeTab = new EventEmitter<number>();

  goToTab(index: number) {
    this.changeTab.emit(index);
  }

  openHugLesson(studentProgressGroup: any) {
    this.updateProgress(studentProgressGroup);
  }

  getAssociatedStudents() {
    this.studentInfo.school = this.selectedSchool;
    this.apiService
      .getAllAssociatedStudents(this.tutorId, this.studentInfo)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.studentList = res.student;
          this.studentListLoadingInProgress = false;
          this.filteredStudentList = res.student;
        }
      });
  }
  findZoomLink() {
    return this.schoolList.find((school)=>this.selectedSchool===school.id)?.zoom_link || "";
  }
    
  onSchoolChange(event: any) {
    this.selectedSchool = event.value;
    this.zoomLink = this.findZoomLink();
    this.studentList = [];
    this.lessonOptions = [];
    this.isLessonSelected = false;
    this.studentId = this.selectedStudent = -1;
    this.selectedLesson1 = -1;
    this.studentListLoadingInProgress = true;
    const trainingSchool = this.schoolList.find(school => school.uuid === sesssionConstants.trainingSchoolUuid);
    this.isTrainingSchool = trainingSchool ? event.value === trainingSchool.id : false;
    if (this.loggedInUserRoleId === StudentConstants.TUTOR_ROLE_ID) {
      this.getAssociatedStudents();
    } else {
      this.getStudentList();
    }
  }
  getStudentList() {
    this.studentInfo.school = this.selectedSchool;
    this.apiService
      .getAllStudents(this.studentInfo)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        this.studentList = res.student;
        this.filteredStudentList = res.student;
        this.studentListLoadingInProgress = false;
      });
  }
  async onStudentChange(event: any) {
    this.lessonOptions = [];
    this.selectedLesson1 = -1;
    this.studentId = this.selectedStudent = event.value;
    try {
      await this.setGradeIds(); // Wait for setGradeIds to complete
      this.lessonsLoaded = false;
    } catch (error) {
      console.error("Error setting grade IDs:", error);
      // Handle the error appropriately
    }
    this.selectedLesson = {};
    this.isLessonSelected = false;
    this.getSelectedStudentDetails();
    if (!isNaN(this.lessonId)) {
      this.getProgressDetails({
        studentId: this.studentId,
        lessonId: this.lessonId,
      });
      this.edit = true;
    }

    this.lessonControl.valueChanges.subscribe((value) => {
      this.lessonOptions = StudentUtility.filterOptions(this.lessons, value, [
        "lesson_name",
      ]);
    });
    if (this.selectedLesson1 != -1) {
      this.setSelectedLesson(this.selectedLesson1);
    }
    this.getData(this.edit);
  }
  setGradeIds(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService
        .getStudent(this.studentId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res) => {
            if (res && res.gradeIddd !== undefined) {
              this.gradeId = res.gradeIddd;
              resolve(); // Resolve the promise when the API call is successful
            } else {
              reject(new Error("Failed to set grade ID")); // Reject the promise if the API call fails
            }
          },
          (error) => {
            console.error("Error in setGradeIds:", error);
            reject(error); // Reject the promise if there's an error
          }
        );
    });
  }

  async getProgressDetails(progress: any) {
    this.loading = true;
    this.apiService
      .getProgressByLesson(progress)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.progressDetails = res;
          this.setForm();
        }
      });
    this.loading = false;
  }

  initializeForm() {
    // Current page means the next page to be loaded next time if the session is not fully completed!
    this.updateStudentProgressGroup = new UntypedFormGroup({
      student: new UntypedFormControl(this.studentId),
      lesson: new UntypedFormControl("", Validators.required),
      volunteer: new UntypedFormControl(""),
      recorded_date: new UntypedFormControl(new Date(), Validators.required),
      curriculum_name: new UntypedFormControl(""),
      reason: new UntypedFormControl(""),
      control_group: new UntypedFormControl(false),
      current_page: new UntypedFormControl(enagagementTabs.preEngagement),
    });
  }

  setForm() {
    if (!isNaN(this.lessonId)) {
      // Current page means the next page to be loaded next time if the session is not fully completed!
      this.updateStudentProgressGroup.patchValue({
        student: this.studentId,
        recorded_date: this.progressDetails.date,
        curriculum_name: this.progressDetails.curriculum_name,
        volunteer: this.progressDetails.volunteer_id,
        lesson: this.progressDetails.lesson_id,
        reason: "",
        control_group: false,
        current_page: enagagementTabs.preEngagement,
      });
    }
  }
  setSelectedReasoForAbsence(event) {
    this.selectedReasonForAbsence = event;
  }

  updateProgress(progress: any) {
    progress.volunteer = this.tutorId;
    progress.reason = this.selectedReasonForAbsence;
    progress.curriculum_name = this.selectedLesson?.curriculum_name || progress.curriculum_name || this.progressDetails?.curriculum_name || null;
    this.loading = true;
    progress.student = this.selectedStudent;
    if (!this.edit) {
      if (!this.wasStudentAbsent) {
        this.getUpdateNewProgress(progress);
      } else {
        this.getUpdateAbsence(progress);
      }
    }
    this.loading = false;
  }
  getUpdateNewProgress(progress) {
    if (this.updateStudentProgressGroup.valid) {
      this.apiService.updateNewProgress(progress).subscribe(
        (res) => {
          if (res) {
            this.goToTab(res.data?.current_page);
            progress.current_page = res.data?.current_page;
            progress.session_id = res.data?.insertId;
            progress.curriculum_name = res.data?.curriculum_name || progress.curriculum_name;
            progress.isTrainingSchool = this.isTrainingSchool;
            StorageService.setSessionData(progress);
            // this.shareProgressData.emit(progress);
          }
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          this.toastrService.error(errorMessages.UPDATE_PROGRESS_FAILED);
        }
      );
    } else {
      this.toastrService.error(
        "Please fill all the required fields before submitting."
      );
      this.loading = false;
    }
  }

  getUpdateAbsence(progress) {
    if (
      this.reasonControl.value &&
      progress.lesson !== -1 &&
      progress.recorded_date &&
      this.selectedSchool !== -1
    ) {
      this.apiService.updateNewProgress(progress).subscribe(
        (res) => {
         if (res) {
            sessionStorage.setItem(
              "absenceSuccessMessage",
              SuccessMessages.UPDATE_ABSENCE
            );

            location.reload();
          } else {
            this.toastrService.error(
              "Absence for the lesson was already marked for the respective student"
            );
          }
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        }
      );
    } else {
      this.toastrService.error("Please fill all the required fields");
      this.loading = false;
    }
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
